// extracted by mini-css-extract-plugin
export default {"title":"job-textbox-section_title__4HR+7","content":"job-textbox-section_content__EOVI9"};